document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.getElementById('ghostdata-container');
  if (!wrapper) return;

  function safe(label, fn) {
    try {
      fn();
    } catch (err) {
      console.error('[ghost-order-options] ' + label + ' failed:', err);
    }
  }

  // ---------------------------------------------------------------------
  // Special Request -> checkbox reveals the text box
  // ---------------------------------------------------------------------
  safe('special request toggle', function () {
    var specialRequestToggle = wrapper.querySelector('#special-request-toggle');
    var specialRequestWrap = wrapper.querySelector('#special-request-wrap');
    if (!specialRequestToggle || !specialRequestWrap) return;

    var toggleSpecialRequest = function () {
      specialRequestWrap.style.display = specialRequestToggle.checked ? '' : 'none';
      if (!specialRequestToggle.checked) {
        var input = specialRequestWrap.querySelector('input');
        if (input) input.value = '';
      }
    };
    specialRequestToggle.addEventListener('change', toggleSpecialRequest);
    toggleSpecialRequest();
  });

  // ---------------------------------------------------------------------
  // Delivery Method (pill selector, mandatory, no default selection)
  //   - Nothing selected  -> both date/time fields hidden
  //   - Pickup from store -> both date/time fields hidden
  //   - Courier Delivery  -> date field + time-slot field shown together
  // ---------------------------------------------------------------------
  var deliveryMethodInput = wrapper.querySelector('#delivery-method');
  var deliveryMethodError = wrapper.querySelector('[data-delivery-method-error]');

  function clearDeliveryMethodError() {
    if (deliveryMethodError) deliveryMethodError.style.display = 'none';
  }

  function deliveryMethodIsValid() {
    // If the field isn't on the page for some reason, don't block submission.
    if (!deliveryMethodInput) return true;
    return !!deliveryMethodInput.value;
  }

  safe('delivery method pills', function () {
    var pillGroup = wrapper.querySelector('[data-pill-group="delivery-method"]');
    var pickupWrap = wrapper.querySelector('#pickup-date-wrap');
    var deliveryDateWrap = wrapper.querySelector('#delivery-date-wrap');
    var addressTypeWrap = wrapper.querySelector('#delivery-address-type-wrap');
    var commercialSelect = wrapper.querySelector('#commercial-type');
    var companyNameWrap = wrapper.querySelector('#company-name-wrap');
    var hospitalNameWrap = wrapper.querySelector('#hospital-name-wrap');
    if (!pillGroup || !deliveryMethodInput) return;

    function toggleDeliveryFields() {
      var value = deliveryMethodInput.value;
      var isCourier = value === 'Courier Delivery';
      if (addressTypeWrap) addressTypeWrap.style.display = isCourier ? '' : 'none';
      if (commercialSelect) {
        // The theme's native Add to Cart path also serializes named controls.
        // Removing the name AND disabling the field prevents a stale default
        // Residential value from becoming a Shopify line-item property.
        if (isCourier) commercialSelect.setAttribute('name', 'properties[Commercial]');
        else commercialSelect.removeAttribute('name');
        commercialSelect.disabled = !isCourier;
      }
      // Keep the address-specific properties out of the cart for store pickup.
      [companyNameWrap, hospitalNameWrap].forEach(function (section) {
        if (!section) return;
        section.querySelectorAll('input, select, textarea').forEach(function (field) {
          if (isCourier) {
            if (field.dataset.ghostOriginalName) field.setAttribute('name', field.dataset.ghostOriginalName);
          } else if (field.hasAttribute('name')) {
            field.dataset.ghostOriginalName = field.getAttribute('name');
            field.removeAttribute('name');
          }
          field.disabled = !isCourier;
        });
      });
      if (companyNameWrap) companyNameWrap.style.display = isCourier && commercialSelect && commercialSelect.value === 'Commercial' ? '' : 'none';
      if (hospitalNameWrap) hospitalNameWrap.style.display = isCourier && commercialSelect && commercialSelect.value === 'Hospital' ? '' : 'none';
      if (value === 'Courier Delivery') {
        if (pickupWrap) pickupWrap.style.display = '';
        if (deliveryDateWrap) deliveryDateWrap.style.display = '';
      } else {
        if (pickupWrap) pickupWrap.style.display = 'none';
        if (deliveryDateWrap) deliveryDateWrap.style.display = 'none';
      }
    }

    var pills = Array.prototype.slice.call(pillGroup.querySelectorAll('.ghost-pill'));
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        deliveryMethodInput.value = pill.dataset.pillValue;
        clearDeliveryMethodError();
        toggleDeliveryFields();
      });
    });
    toggleDeliveryFields();
  });

  // ---------------------------------------------------------------------
  // Please Choose One -> show/hide Company name (Commercial) and
  // Hospital name (Hospital)
  // ---------------------------------------------------------------------
  safe('commercial/hospital toggle', function () {
    var commercialSelect = wrapper.querySelector('#commercial-type');
    var companyNameWrap = wrapper.querySelector('#company-name-wrap');
    var hospitalNameWrap = wrapper.querySelector('#hospital-name-wrap');
    if (!commercialSelect) return;

    var toggleTypeFields = function () {
      if (companyNameWrap) {
        companyNameWrap.style.display = deliveryMethodInput && deliveryMethodInput.value === 'Courier Delivery' && commercialSelect.value === 'Commercial' ? '' : 'none';
      }
      if (hospitalNameWrap) {
        hospitalNameWrap.style.display = deliveryMethodInput && deliveryMethodInput.value === 'Courier Delivery' && commercialSelect.value === 'Hospital' ? '' : 'none';
      }
    };
    commercialSelect.addEventListener('change', toggleTypeFields);
    toggleTypeFields();
  });

  // ---------------------------------------------------------------------
  // Add-on checkboxes -> "Gift wrapping" property summary + live price total
  // ---------------------------------------------------------------------
  var addonCheckboxes = wrapper.querySelectorAll('.addon-checkbox');

  safe('addon totals', function () {
    var summaryInput = wrapper.querySelector('[data-addon-summary]');
    var addonTotalWrap = wrapper.querySelector('[data-addon-total]');
    var addonTotalAmount = wrapper.querySelector('[data-addon-total-amount]');

    function updateAddons() {
      var checked = Array.prototype.filter.call(addonCheckboxes, function (c) { return c.checked; });

      if (summaryInput) {
        summaryInput.value = checked.map(function (c) { return c.value; }).join(',');
      }

      var total = checked.reduce(function (sum, c) {
        return sum + (parseFloat(c.dataset.price) || 0);
      }, 0);

      if (addonTotalAmount) addonTotalAmount.textContent = '$' + total.toFixed(2);
      if (addonTotalWrap) addonTotalWrap.style.display = total > 0 ? '' : 'none';

      document.dispatchEvent(new CustomEvent('ghost:addons-changed', { detail: { total: total } }));
    }

    addonCheckboxes.forEach(function (cb) { cb.addEventListener('change', updateAddons); });
    updateAddons();
  });

  // ---------------------------------------------------------------------
  // Gift Card Message -> simple textarea, 200-char limit with live counter.
  // Required unless the customer types "NONE" (any non-empty value passes).
  // ---------------------------------------------------------------------
  var giftInput = wrapper.querySelector('#gift-card-message');
  var giftError = wrapper.querySelector('[data-gift-card-error]');

  function clearGiftError() {
    if (giftError) giftError.style.display = 'none';
  }

  function showGiftError() {
    if (giftError) giftError.style.display = '';
  }

  function giftIsValid() {
    // If the field isn't on the page for some reason, don't block submission.
    if (!giftInput) return true;
    return !!(giftInput.value && giftInput.value.trim().length > 0);
  }

  safe('gift card message counter', function () {
    var giftCharCount = wrapper.querySelector('[data-gift-card-char-count]');
    if (!giftInput) return;
    var GIFT_MAX_LENGTH = parseInt(giftInput.getAttribute('maxlength'), 10) || 200;

    function updateGiftCharCount() {
      if (!giftCharCount) return;
      var remaining = GIFT_MAX_LENGTH - giftInput.value.length;
      giftCharCount.textContent = remaining + ' Characters remaining';
    }

    giftInput.addEventListener('input', function () {
      clearGiftError();
      updateGiftCharCount();
    });
    updateGiftCharCount();
  });

  // ---------------------------------------------------------------------
  // Submit handling: block only on genuinely invalid fields, then queue
  // add-ons as separate cart line items. Wrapped defensively so a bug here
  // can never silently swallow the main "Add to cart" submission.
  // ---------------------------------------------------------------------
  var orderGroupInput = wrapper.querySelector('[data-order-group]');

  var submitting = false;

  function goToCart() {
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  async function handleGhostOrderSubmit(evt) {
    var hasError = false;
    try {
      if (!deliveryMethodIsValid()) {
        hasError = true;
        if (deliveryMethodError) deliveryMethodError.style.display = '';
      } else clearDeliveryMethodError();

      if (!giftIsValid()) {
        hasError = true;
        showGiftError();
      } else clearGiftError();
    } catch (err) {
      console.error('[ghost-order-options] validation error:', err);
      hasError = true;
    }

    if (hasError) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      return;
    }

    var checkedAddons = Array.from(wrapper.querySelectorAll('.addon-checkbox:checked'));
    if (!checkedAddons.length) {
      if (orderGroupInput) orderGroupInput.value = '';
      return; // Preserve the theme's original no-add-on workflow.
    }

    evt.preventDefault();
    evt.stopImmediatePropagation();
    if (submitting) return;
    submitting = true;

    var form = evt.target;
    var submitButton = evt.submitter || form.querySelector('[type="submit"], button[name="add"]');
    if (submitButton) submitButton.disabled = true;

    try {
      var data = new FormData(form);
      // The options block may be outside the native product form in this theme.
      // Include its named controls in that case, without duplicating form fields.
      if (!form.contains(wrapper)) {
        wrapper.querySelectorAll('input[name], select[name], textarea[name]').forEach(function (field) {
          if (field.disabled || ((field.type === 'checkbox' || field.type === 'radio') && !field.checked)) return;
          data.set(field.name, field.value);
        });
      }

      var mainVariantId = String(data.get('id') || '');
      if (!/^\d+$/.test(mainVariantId)) throw new Error('Main product variant ID missing or invalid');
      var qty = Number(data.get('quantity') || 1);
      if (!Number.isInteger(qty) || qty < 1) throw new Error('Invalid product quantity');

      var orderGroup = Date.now().toString() + '-' + Math.random().toString(36).slice(2, 9);
      if (orderGroupInput) orderGroupInput.value = orderGroup;
      var properties = {};
      for (var pair of data.entries()) {
        var match = /^properties\[(.+)\]$/.exec(pair[0]);
        if (match && typeof pair[1] === 'string') properties[match[1]] = pair[1];
      }
      // Never submit delivery-address properties for store pickup, even if
      // stale hidden inputs were serialized by the theme or another script.
      if (deliveryMethodInput && deliveryMethodInput.value === 'Pickup from store') {
        ['Commercial', 'Company Name', 'Hospital Name'].forEach(function (key) {
          delete properties[key];
        });
      }
      properties._io_order_group = orderGroup;
      properties['Gift wrapping'] = checkedAddons.map(function (cb) { return cb.value; }).join(',');

      var items = [{ id: Number(mainVariantId), quantity: qty, properties: properties }];
      checkedAddons.forEach(function (cb) {
        if (!/^\d+$/.test(String(cb.dataset.variantId || ''))) throw new Error('Invalid gift variant ID');
        items.push({ id: Number(cb.dataset.variantId), quantity: 1, properties: { _io_order_group: orderGroup } });
      });

      var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      var response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      var result = await response.json();
      if (!response.ok || result.status >= 400) {
        throw new Error(result.description || result.message || 'Shopify rejected cart request');
      }
      if (!Array.isArray(result.items) || !result.items.some(function (item) {
        return String(item.variant_id || item.id) === mainVariantId;
      })) throw new Error('Main product not confirmed in Shopify response');
      goToCart();
    } catch (err) {
      console.error('[ghost-order-options] cart submission failed:', err);
      alert('We could not add your arrangement to the cart. Please try again. ' + err.message);
      submitting = false;
      if (submitButton) submitButton.disabled = false;
    }
  }

  // Try binding directly to the form if we can find one nesting the options
  // block (fastest, most predictable). This also covers themes where the
  // options block sits in a slot next to the <form> rather than inside it,
  // by falling back to a delegated, containment-checked document listener
  // that fires regardless of exactly where the block is placed in the DOM.
  var directForm = wrapper.closest('form');
  if (directForm) {
    directForm.addEventListener('submit', handleGhostOrderSubmit);
  } else {
    document.addEventListener('submit', function (evt) {
      var submittedForm = evt.target;
      if (!submittedForm || typeof submittedForm.contains !== 'function') return;
      // Only handle this if the submitted form is inside the same product
      // form component as our options block, or actually contains it.
      var container = wrapper.closest('product-form-component') || document.body;
      if (!container.contains(submittedForm) && !submittedForm.contains(wrapper)) return;
      handleGhostOrderSubmit(evt);
    }, true);
  }
});